export default "__VITE_ASSET__bea2b346__"